import VerificationLayout from "../VerificationMethodLayout";

const FileHostVerification = () => {
  return (
    <VerificationLayout verifyType="Mail and call Organization Administrator">FileHostVerification</VerificationLayout>
  );
};

export default FileHostVerification;
